import { render, staticRenderFns } from "./szsx.vue?vue&type=template&id=397993ec&"
import script from "./szsx.vue?vue&type=script&lang=ts&"
export * from "./szsx.vue?vue&type=script&lang=ts&"
import style0 from "./szsx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports